import { FC } from "react";
import dayjs, { Dayjs } from "dayjs";
import { IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

type Props = {
  selectedDate: Dayjs;
  onDateChange: (date: Dayjs) => void;
};

export const DateNavigation: FC<Props> = ({ selectedDate, onDateChange }) => {
  const isToday = selectedDate.isSame(dayjs(), "day");
  const strongColor = isToday ? "#2E7D32" : "#C62828";
  const lightColor = isToday ? "#E8F5E9" : "#FFEBEE";

  const handlePrev = () => {
    onDateChange(selectedDate.subtract(1, "day"));
  };

  const handleNext = () => {
    if (!isToday) {
      onDateChange(selectedDate.add(1, "day"));
    }
  };

  return (
    <div className="mt-6 mb-4 flex items-center gap-2">
      <h2 className="text-lg text-gray-400">Date</h2>
      <IconButton onClick={handlePrev} size="small">
        <ChevronLeftIcon />
      </IconButton>

      <div
        className="flex items-center justify-center gap-2 px-3 rounded-lg"
        style={{
          backgroundColor: lightColor,
          height: 34,
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={selectedDate}
            onChange={(val) => {
              if (val && val.isValid()) {
                const today = dayjs();
                onDateChange(val.isAfter(today, "day") ? today : val);
              }
            }}
            maxDate={dayjs()}
            format="MMMM DD, YYYY"
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: 160,
                  "& .MuiOutlinedInput-root": {
                    height: 30,
                  },
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "& .MuiInputBase-input": {
                    fontWeight: 600,
                    textAlign: "center",
                    color: strongColor,
                    padding: "4px 0",
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </div>

      <IconButton onClick={handleNext} size="small" disabled={isToday}>
        <ChevronRightIcon />
      </IconButton>
    </div>
  );
};
